/**
 * GA4 screen_name / step enums for onboarding.
 */

export type ScreenName =
    | 'terms'
    | 'registration_form'
    | 'email_otp'
    | 'phone_otp'
    | 'verification_method'
    | 'sumsub'
    | 'imid'
    | 'imid_pending'
    | 'imid_result'
    | 'contract'
    | 'contract_otp'
    | 'registration_completed'
    | 'registration_failed';

/** Includes reserved catalog steps not yet mapped from routes. */
export const REGISTRATION_STEPS = [
    'registration_form',
    'email_otp',
    'phone_otp',
    'verification_method',
    'sumsub',
    'imid',
    'contract',
    'contract_otp',
    'customer_creation',
    'account_creation',
    'mb_login_creation',
    'mb_full_access_provision',
] as const;

export type RegistrationStep = (typeof REGISTRATION_STEPS)[number];

export const REGISTRATION_STEP_SET: ReadonlySet<RegistrationStep> = new Set(
    REGISTRATION_STEPS
);

const PATH_TO_SCREEN: Record<string, ScreenName> = {
    '/': 'terms',
    '/info': 'registration_form',
    '/email': 'email_otp',
    '/phone': 'phone_otp',
    '/verification-options': 'verification_method',
    '/sumsub': 'sumsub',
    '/imid-verification': 'imid',
    '/imid-verification-pending': 'imid_pending',
    '/imid-verification-result': 'imid_result',
    '/conditions': 'contract',
    '/otp': 'contract_otp',
    '/congratulation': 'registration_completed',
    '/error': 'registration_failed',
};

/** Map screen_name → registration_failed / abandoned `step` (funnel stage). */
const SCREEN_TO_STEP: Partial<Record<ScreenName, RegistrationStep>> = {
    registration_form: 'registration_form',
    email_otp: 'email_otp',
    phone_otp: 'phone_otp',
    verification_method: 'verification_method',
    sumsub: 'sumsub',
    imid: 'imid',
    imid_pending: 'imid',
    imid_result: 'imid',
    contract: 'contract',
    contract_otp: 'contract_otp',
};

/** Map a privacy-safe SPA path (pathname only) to screen_name. */
export function pathToScreenName(path: string | null | undefined): ScreenName | null {
    if (!path) {
        return null;
    }
    const pathname = path.split('?')[0] || '/';
    return PATH_TO_SCREEN[pathname] ?? null;
}

/** Map screen_name to registration_failed / abandoned step when possible. */
export function screenNameToStep(screen: ScreenName | null): RegistrationStep | null {
    if (!screen) {
        return null;
    }
    return SCREEN_TO_STEP[screen] ?? null;
}
